import { getStore } from "store";
import { clearWarningState } from "actions/warning-actions";

export function onLeave() {
    getStore().dispatch(clearWarningState());
}
